<template>
  <section class="admin-content" id="contact-search">
    <Navbar />
    <main class="admin-main">
      <div class="bg-dark">
        <div class="container m-b-30">
          <div class="row">
            <div class="col-12 text-white p-t-40 p-b-90">
              <h4 class="">
                <span class="btn btn-white-translucent">
                  <i class="mdi mdi-table"></i
                ></span>
                Enrollee Deleting Tool
              </h4>
              <p class="opacity-75">
                With this tool, we can verify your enrollees before they are
                deleted from the agency.
              </p>
              <hr />
              <br />

              <div class="row">
                <div class="col-md-12">
                  <button class="btn btn-info" @click="getData">
                    <i class="fe fe-plus"></i> Get Due for De-activation
                  </button>

                  <button
                    class="btn btn-outline-danger ml-3 my-2"
                    @click="filterparams = !filterparams"
                  >
                    <i class="fe fe-filter"></i> Filter Deactivated
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-md-12 mb-5">
        <div class="card" v-show="filterparams">
          <div class="card-header">
            <p class="text-center h4">Filter Parameter</p>
          </div>
          <div class="card-body">
            <div class="row">
              <div class="form-group col-md-3">
                <label for="inputEmail4">Enrollee ID</label>
                <input
                  type="text"
                  class="form-control"
                  v-model="filter_field.id_card_number"
                  placeholder="ID/XXX/XXXXX"
                />
              </div>

              <div class="form-group col-md-3">
                <label> Select Program </label>
                <select class="form-control" v-model="filter_field.sector">
                  <option
                    :value="sector"
                    v-for="sector in sectors"
                    :key="sector"
                  >
                    {{ sector }}
                  </option>
                </select>
              </div>

              <div class="form-group col-md-3">
                <label for="inputCity"
                  ><i class="fe fe-calendar"></i> Start Date
                </label>
                <input
                  type="date"
                  class="form-control"
                  v-model="filter_field.from"
                />
              </div>

              <div class="form-group col-md-3">
                <label for="inputCity"
                  ><i class="fe fe-calendar"></i> End Date
                </label>
                <input
                  type="date"
                  class="form-control"
                  v-model="filter_field.to"
                />
              </div>

              <div class="col-md-12">
                <button
                  class="btn btn-outline-info btn-block"
                  @click="getDeleted"
                >
                  Filter
                </button>

                <button class="btn btn-outline-dark my-2 btn-block">
                  <download-excel
                    :data="info.data"
                    :fields="json_fields"
                    type="xls"
                    :escapeCsv="false"
                    :name="'Deleted Data' + '.xls'"
                  >
                  </download-excel>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="container">
        <div class="row">
          <div class="col-md-7">
            <div class="card m-b-30">
              <div class="card-header">
                <h5 class="m-b-0">
                  <i class="mdi mdi-checkbox-intermediate"></i> Data Info
                  {{ info.meta.total }}
                </h5>
              </div>
              <div class="card-body">
                <div class="table-responsive">
                  <table class="table table-hover">
                    <thead>
                      <tr>
                        <th>Type</th>
                        <th>Full Name</th>
                        <th>DOB</th>
                        <th>Sector</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="ins in info.data" v-bind:key="ins.id">
                        <td>{{ ins.account_type }}</td>
                        <td>{{ ins.full_name }}</td>
                        <td>
                          {{ ins.dob }}
                        </td>

                        <td>{{ ins.sector }}</td>
                        <td>
                          <button
                            class="btn btn-outline-info"
                            @click="selectEnrollee(ins)"
                          >
                            <i class="fe fe-eye"></i>
                          </button>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>

          <div class="col-md-5">
            <div class="card">
              <div class="card-header">
                <p class="h4 text-center">Enrollee Details</p>
              </div>
              <div>
                <div class="card-body">
                  <div class="text-center" v-if="selected == ''">
                    <i
                      class="las la-folder-open la-3x text-info text-center"
                    ></i>
                    <p class="h5 text-info">No Enrollee selected Yet</p>
                  </div>

                  <div class="" v-if="selected != ''">
                    <div class="col-md-12">
                      <img
                        :src="`https://claimify-api.hayokmedicare.ng/image/${selected.user_image}`"
                        class="img-thumbnail mt-3"
                        onerror="this.onerror=null; this.src='/kschma_logo.jpg'"
                      />
                    </div>

                    <div class="col-md-12">
                      <p class="h6 spacer-top-bottom">
                        {{ selected.full_name }}
                      </p>
                      <hr />

                      <p class="h6 spacer-top-bottom">
                        {{ selected.id_card_number }}
                      </p>
                      <hr />
                      <p class="h6 spacer-top-bottom">
                        {{ selected.account_type }}
                      </p>

                      <hr />
                      <p class="h6 spacer-top-bottom">
                        {{ selected.sector }}
                      </p>
                      <hr />

                      <p class="h6 spacer-top-bottom">
                        {{ selected.phone_number }}
                      </p>
                      <hr />

                      <hr />
                      <p class="h6 spacer-top-bottom">
                        Date of Birth: {{ selected.dob }} ({{
                          selected.dob | moment("from", "now")
                        }})
                      </p>

                      <hr />
                      <p
                        class="h6 spacer-top-bottom"
                        v-if="selected.place_of_work != null"
                      >
                        <strong> {{ selected.place_of_work }}</strong>
                      </p>
                      <hr />

                      <p class="h6 spacer-top-bottom">
                        Date of First Appointment:
                        {{ selected.date_of_entry }}
                        ({{ selected.date_of_entry | moment("from", "now") }})
                      </p>

                      <p class="h6 spacer-top-bottom">
                        Date of Expiry:
                        {{ selected.date_of_expiry }}
                      </p>

                      <p class="h6 spacer-top-bottom">
                        Date of Delete:
                        {{ selected.deleted_at }}
                      </p>
                    </div>

                    <div class="row my-8">
                      <div class="col-md-6">
                        <button
                          class="btn btn-success btn-block"
                          @click="date_form = true"
                        >
                          Renew Expiration
                        </button>
                      </div>
                      <div class="col-md-6">
                        <button
                          class="btn btn-danger btn-block"
                          @click="disableUser(selected)"
                        >
                          Disable User
                        </button>
                      </div>
                    </div>

                    <div class="row my-8" v-show="date_form">
                      <div class="col-md-6">
                        <input
                          type="date"
                          v-model="date_of_expiry"
                          class="form-control"
                        />
                      </div>

                      <div class="col-md-6">
                        <button
                          class="btn btn-success btn-block"
                          @click="enableUser(selected)"
                        >
                          Submit
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="vld-parent">
        <loading
          :active.sync="isLoading"
          loader="dots"
          :can-cancel="true"
          :is-full-page="fullPage"
        ></loading>
      </div>
    </main>
  </section>
</template>

<script>
import Navbar from "@/views/Navbar.vue";
import SectorsJson from "@/json/sectors.json";
import Loading from "vue-loading-overlay";
// Import stylesheet
import "vue-loading-overlay/dist/vue-loading.css";
let agency = JSON.parse(localStorage.getItem("agency"));

export default {
  components: {
    Navbar,
    Loading,
  },
  data() {
    return {
      agency: agency,

      filterparams: false,
      isLoading: false,
      fullPage: true,
      filter_field: {
        sector: "",
        id_card_number: "",
        from: "",
        to: "",
      },
      sectors: SectorsJson,
      date_form: false,
      lga_states: [],
      info: {
        meta: {},
        data: [],
      },
      selected: "",
      date_of_expiry: "",
      seen: true,
      json_fields: {
        "Full Name": "full_name",
        "ID ": "id_card_number",
        "Phone Number": "phone_number",
        Program: "sector",
        "Date Deleted": "deleted_at",
      },
    };
  },
  methods: {
    getData() {
      this.isLoading = true;
      this.axios
        .post(`/api/v1/auth/get-expiry-due/${agency.id}`)
        .then((response) => {
          this.isLoading = false;
          this.info = response.data;
        })
        .catch((error) => {
          console.error(error);
          this.isLoading = false;
        });
    },
    disableUser(selected) {
      if (confirm("Are you Sure?")) {
        this.axios
          .post(`/api/v1/auth/disableUser/` + selected.id)
          .then(() => {
            this.$toasted.info("Deleted Successfully!", {
              position: "top-center",
              duration: 8000,
            });
          })
          .catch((error) => {
            console.error(error);
          });
      }
    },
    enableUser(user) {
      if (confirm("Are you Sure you want to Approve?")) {
        this.axios
          .patch(`/api/v1/auth/extend-expiry/${user.id}`, {
            expiry_date: this.date_of_expiry,
          })
          .then(() => {
            this.$toasted.success("Changed Successfully", {
              position: "top-center",
              duration: 3000,
            });
            this.selected = "";
            this.getData();
          })
          .catch((error) => {
            console.error(error);
            alert(error);
          });
      }
    },

    selectEnrollee(enrollee) {
      this.selected = enrollee;
      console.log(this.selected);
    },
    getDeleted() {
      this.isLoading = true;
      this.axios
        .post(`/api/v1/auth/get-deleted`, {
          agency_id: this.filter_field.agency_id,
          id_card_number: this.filter_field.id_card_number,
          sector: this.filter_field.sector,
          from: this.filter_field.from,
          to: this.filter_field.to,
        })
        .then((response) => {
          this.info = response.data;
          this.isLoading = false;
        })
        .catch((error) => {
          console.error(error);
          this.isLoading = false;
        });
    },
  },
  created() {
    this.getData();
  },
};
</script>

<style scoped>
.spacer-top-bottom {
  margin-top: 10px;
  margin-bottom: 10px;
}
</style>
